// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"4b5af159","209":"0a486ef8","478":"43a79ba1","625":"7493b828","824":"d52711c3","868":"db9101d9","922":"72786cd4"}[chunkId] + ".chunk.js";
};